<template>
    <dashboard class="reports">
        <heading>
            <h1 slot="title">Reports</h1>
        </heading>
        <panel v-for="report in reports" 
               :key="report.parent" 
               class="report-option" 
               size="col-24">
            <h3 slot="title">{{ report.parent }}</h3>
            <div class="report-category">
                <div class="card-options">
                    <app-card
                        v-for="type in report.children"
                        :key="type.title"
                        class="report-type-card"
                        @click="$router.push({ name: type.link })">
                        <template slot="title">{{ type.title }}</template>
                        {{ type.description }}
                    </app-card>
                </div>
            </div>
        </panel>
    </dashboard>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'page-reports',
    components: { },
    head: {
        title: {
            inner: 'Reports'
        }
    },
    computed: {
        ...mapGetters(['role']),
        reports() {
            if (this.$role.isAdmin()) {
                return [
                    {
                        parent: 'Attendance Reports',
                        children: [
                            {
                                title: 'Status',
                                description:
                                    'Full list of each individual attendance item',
                                link: 'reports.status'
                            },
                            {
                                title: 'Course',
                                description:
                                    'Student attendance summary for one course across classes',
                                link: 'reports.class'
                            },
                            {
                                title: 'Event Signup',
                                description:
                                    'Overview of what students are registered for an event',
                                link: 'reports.event'
                            },
                            {
                                title: 'Student',
                                description: 'An attendance summary for an individual student',
                                link: 'reports.student'
                            },
                            {
                                title: 'Team',
                                description: 'Attendance summaries for all students in a given team',
                                link: 'reports.team'
                            },
                            {
                                title: 'Canvas Export',
                                description: 'An exportable file to import attendance for a given course into Canvas',
                                link: 'reports.canvas'
                            },
                            {
                                title: 'Last Date of Attendance',
                                description: 'List of students last date of attendance in general or for a course',
                                link: 'reports.lastattendance'
                            }
                        ]
                    },
                    {
                        parent: 'Troubleshooting Reports',
                        children: [
                            {
                                title: 'Token',
                                description:
                                    'Get list of all students who have not yet put their token in',
                                link: 'reports.token'
                            },
                            {
                                title: 'Setup / Issues',
                                description:
                                    'Know what students may be having issues with Spotter',
                                link: 'reports.setup'
                            }
                        ]
                    },
                    {
                        parent: 'Administrator Reports',
                        children: [
                            {
                                title: 'Presence Report',
                                description: 'View all activity in a given location over the course of a day',
                                link: 'reports.presence'
                            },
                            {
                                title: 'Cancellations',
                                description: 'View cancellations across all courses over a time period',
                                link: 'reports.cancellation'
                            },
                            {
                                title: 'Beacons / Assets',
                                description:
                                    'View all beacons on a campus along with battery information',
                                link: 'reports.beacon'
                            }
                        ]
                    }
                ]
            }
            else {
                return [
                    {
                        parent: 'Attendance Reports',
                        children: [
                            {
                                title: 'Status Report',
                                description:
                                    'Full list of each individual attendance item',
                                link: 'reports.status'
                            },
                            {
                                title: 'Course',
                                description:
                                    'Student attendance summary for one course across classes',
                                link: 'reports.class'
                            },
                            {
                                title: 'Event Signup',
                                description:
                                    'Overview of attendance for students in one event',
                                link: 'reports.event'
                            },
                            {
                                title: 'Canvas Export',
                                description: 'An exportable file to import attendance for a given course into Canvas',
                                link: 'reports.canvas'
                            },
                            {
                                title: 'Student',
                                description: 'An attendance summary for an individual student',
                                link: 'reports.student'
                            },
                            {
                                title: 'Team',
                                description: 'Attendance summaries for all students in a given team',
                                link: 'reports.team'
                            }
                        ]
                    },
                    {
                        parent: 'Troubleshooting Reports',
                        children: [
                            {
                                title: 'Tokens',
                                description:
                                    'Get list of all students who have not yet put their token in',
                                link: 'reports.token'
                            },
                            {
                                title: 'Setup / Issues',
                                description:
                                    'Know what students may be having issues with Spotter',
                                link: 'reports.setup'
                            }
                        ]
                    }
                ]
            }
        }
    }
}
</script>

<style lang="stylus">
.report-option
    padding-bottom: 20px

.report-type-card
    width: 100%

.card-options
    display: grid
    grid-template-columns: 1fr 1fr 1fr 1fr
    grid-column-gap: 20px
    grid-row-gap: 20px
    margin-top: 20px

    @media screen and (max-width: 1024px)
        display: block

.report-type-card
    @media screen and (max-width: 1024px)
        margin-bottom: 20px
</style>
